import { Col, Row } from "antd";
import React from "react";

import styles from "./serviceProfileComp.module.css";
import Box from "../box/Box";

const ServiseProfileComponent = ({ image, children }) => {
  return (
    <>
      <Row className={styles.mainCont}>
        <Col className={styles.imageCont}>
          <img src={image} alt="service image" className={styles.image} />
        </Col>
        <Col className={styles.contentCont}>{children}</Col>
      </Row>
    </>
  );
};

export default ServiseProfileComponent;
